module.exports = __webpack_public_path__ + "static/media/icon-chat.05e7cd39.svg";